import { useEffect, useState } from 'react'
import { isMobileDevice } from '../../lib/is-mobile-device'
import { Icon } from '../icons/Icon'
import Link from '../navigation/Link'

type Props = {
  variant?: 'dark' | 'light'
  showNumber?: boolean
  className?: string
  iconClassName?: string
}

export default function PhoneContactLink({
  variant = 'dark',
  showNumber = false,
  className = 'flex items-center gap-2',
  iconClassName,
}: Props) {
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    setIsMobile(isMobileDevice())
  }, [])

  const iconColor = variant === 'light' ? '#fff' : '#01A8B2'

  const icon = (
    <Icon
      name="basic/phone-call"
      size="20px"
      className={iconClassName}
      color={iconColor}
    />
  )

  const number = showNumber ? (
    <p
      className={`
        inline-flex text-base-bold

        ${variant === 'light' ? 'text-white' : 'text-neutral-900'}
      `}
    >
      931 318 618
    </p>
  ) : null

  if (isMobile) {
    return (
      <a
        href="tel:+34931318618"
        className={className}
        aria-label="Llamar al 931 318 618"
      >
        {icon}
        {number}
      </a>
    )
  }

  return (
    <Link to={'/contacto'} className={className}>
      {icon}
      {number}
    </Link>
  )
}
